import { render, staticRenderFns } from "./AddOnSurvey.vue?vue&type=template&id=6324c3a5&scoped=true"
import script from "./AddOnSurvey.vue?vue&type=script&lang=js"
export * from "./AddOnSurvey.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6324c3a5",
  null
  
)

export default component.exports